export const CART_BILL_TIP_OTHER = "Other";
export const CART_BILL_TIP_VALUES: Array<number | string> = [50, 80, 100, CART_BILL_TIP_OTHER];
